import React, { useState, Fragment, useRef, createContext, useEffect } from 'react'
import {storage} from '../firebase/firebase';
import {getDownloadURL, ref, uploadBytes, listAll} from 'firebase/storage';
import { Alert, Backdrop, Button, CircularProgress, Grid, Snackbar } from '@mui/material';
import { Box } from '@mui/system';
import {v4} from 'uuid'

import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import imagenVacio from '../Media/images.png'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

const ImportarImagen = (props) => {

    let nuevaURL = '';

    const {
        id,
        setMostrarImagen,
        nodos,
        setNodos,
        handleCloseModalImage
    } = props;

    //Variable con la imagen subida
    //en el input de archivos.
    const [imageUpload, setImageUpload] = useState(null);
    const [placeHolder, setPlaceHolder] = useState(imagenVacio);

    const [open, setOpen] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);

    const [imagenSubida, setImagenSubida] = useState(false);

    const [widthOriginal, setWidthOriginal] = useState('');
    const [heightOriginal, setHeightOriginal] = useState('');

    const [imagenWidth, setImagenWidth] = useState('');
    const [imagenHeight, setimagenHeight] = useState('');

    const handleClose = () => {
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen(true);
    };



    const uploadImage =  async (e) =>{
        handleToggle();
        
        e.preventDefault();
        /* console.log('subiendo imagen') */
        if(imageUpload === null) return;
        const imageRef = ref(storage, `images/${imageUpload.name + v4()}`);

        await uploadBytes(imageRef, imageUpload).then( async (res)=>{
            /* console.log('Imagen subida') */
            handleClose();
            await getDownloadURL(imageRef).then((url)=>{
                /* console.log(url); */
                nuevaURL=url;
            })
        })
        /* console.log({nuevaURL}) */
        handleCloseModalImage();
        await createImage();
    }

    const createImage = (e) =>{
        setMostrarImagen(true);
        const nuevaId = "Img-"+v4();

        setNodos(
            nodos.map((nodo)=>{
                if(id===nodo.id){
                    return {
                        ...nodo,
                        isDragging: false,
                        imgId: nuevaId,
                        urlImagen: nuevaURL,
                        tieneImagen: true,
                        imgWidth: imagenWidth,
                        imgHeight: imagenHeight
                    }
                }else{
                    return {
                        ...nodo,
                        isDragging: false,
                    }
                }
            })
        )
        
        nuevaURL='';
        setWidthOriginal('');
        setHeightOriginal('');
    }

    const handleUploadImage = (e) =>{
        
        setImageUpload(e.target.files[0])

        const archivo = e.target.files[0];


        let fileReader = new FileReader();      
        const url = fileReader.readAsDataURL(archivo);
        setImagenSubida(true);


        fileReader.onloadend = function (e) {
            setPlaceHolder(fileReader.result);
            var img = new Image();
            img.src = fileReader.result;

            img.onload = () =>{
                /* console.log(img.width, img.height) */
                setWidthOriginal(img.width);
                setHeightOriginal(img.height)

                if(img.width>img.height){
                    setImagenWidth(250);
                    setimagenHeight(100);
                }
                if(img.width<img.height){
                    setImagenWidth(100);
                    setimagenHeight(250);
                }
                if(img.width===img.height){
                    setImagenWidth(150);
                    setimagenHeight(150);
                }
            }
        }.bind(this)
    }


    return (
        <div>
            <Box sx={{ flexGrow: 1 }}>
                
                <Grid container direction="row" spacing={4} alignItems="center">
                    <Grid item={true} xs={7}>
                        <img style={{height:150, width:200}} src={placeHolder} alt="preview"/>
                    </Grid>

                    <Grid item={true} xs={5}>
                        <Grid container direction="column" pacing={1}>
                            <Grid item={true} xs={2}>
                                <Button 
                                    color="primary" 
                                    aria-label="upload picture" 
                                    component="label"
                                    startIcon={<AddPhotoAlternateIcon />}  
                                >   
                                    Agregar
                                    <input 
                                        hidden 
                                        accept="image/*"
                                        type="file"
                                        onChange={handleUploadImage}
                                    />
                                </Button>
                            </Grid>
                            <Grid item={true} xs={2}>
                                {imagenSubida ?
                                    (
                                        <Button 
                                            onClick={uploadImage} 
                                            startIcon={<FileUploadIcon/>} 
                                        >
                                            Subir
                                        </Button>
                                    )
                                    :
                                    (
                                        <Button 
                                            disabled
                                            onClick={uploadImage} 
                                            startIcon={<FileUploadIcon/>} 
                                        >
                                            Subir
                                        </Button>
                                    )
                                }
                                
                            </Grid>
                        </Grid>
                    </Grid>
                    
                    
                </Grid>
                    


            </Box>
            

            {open && (
                <>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={open}
                        /* onClick={handleClose} */
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </>
            )}
            {/* <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
                    This is a success message!
                </Alert>
            </Snackbar> */}
        </div>
    )
}

export default ImportarImagen;